import { useEffect, useState } from 'react'

import { ApiService } from '@/services'

export const LIST_ITEM_SKELETON_HEIGHT = '98px'

interface UseListItemsByPathResult<T> {
  items: T[] | null
  isLoading: boolean
  hasError: boolean
  hasPath: boolean
  hasInlineProps: boolean
  style: { marginTop?: string; marginBottom?: string }
}

export function useListItemsByPath<T>(
  path: string | undefined,
  inlineItems: T[],
  sduiStyle?: { marginTop?: string; marginBottom?: string },
): UseListItemsByPathResult<T> {
  const [items, setItems] = useState<T[] | null>(null)
  const [isLoading, setIsLoading] = useState(true)
  const [hasError, setHasError] = useState(false)

  const hasPath = Boolean(path)
  const hasInlineProps = inlineItems.length > 0

  useEffect(() => {
    if (!hasPath || !path) return

    const fetchItems = async () => {
      try {
        setIsLoading(true)
        setHasError(false)

        const response = await ApiService.HOME_CREDIT.getListItemByPath(path)
        if (response?.props?.items?.length) {
          setItems(response.props.items as T[])
        } else {
          setHasError(true)
        }
      } catch {
        setHasError(true)
      } finally {
        setIsLoading(false)
      }
    }

    fetchItems()
  }, [path, hasPath])

  const style = {
    marginTop: sduiStyle?.marginTop,
    marginBottom: sduiStyle?.marginBottom,
  }

  return {
    items,
    isLoading,
    hasError,
    hasPath,
    hasInlineProps,
    style,
  }
}
